import { AppShell } from '@/components/app-shell';
import { useAuthStore } from '@/stores/auth-store';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app')({
  beforeLoad: () => {
    const { token, user } = useAuthStore.getState();
    if (!token || !user) {
      throw redirect({ to: '/login' });
    }
  },
  component: AppShell,
});
